import Vue from 'vue'
import Router from 'vue-router'
import LoginComponent from '../views/login.vue'
import MarketComponent from '../views/market.vue'
import SogComponent from '../views/sog.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: {
        name: 'login'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginComponent
    },
    {
      path: '/market',
      name: 'MarketForm',
      component: MarketComponent,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/sog',
      name: 'SogForm',
      component: SogComponent,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (this.authenticated) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js